module.exports = __webpack_public_path__ + "img/83.1ce3aad2.jpg";